import React, {useContext, useMemo, useState} from "react";
import * as R from "ramda";
import { traduzirNomeColuna } from "app/utils/UtilsColunas";
import { larguraColunaOrdem, larguraPrimeiraColuna } from "../largurasColunasFixas";
import { obterStyleColunasFixas } from "../obterStyleColunasFixas";
import { GridItensContext } from "../GridItens";
const estilosGridItens = require('../grid-itens.module.scss').default


const estilosTableHead = require('./tableHead.module.scss').default


export type TableHeadProps = {
    esconderColunaVazia?: boolean;
}


export const TableHead = (props: TableHeadProps) => {

    const context = useContext(GridItensContext)

    const parametroChaveMovimentacaoOrcamento = useMemo(() =>
        (context.parametrosGridItens ?? []).find(p => p.Nome == "CHAVE_MOVIMENTACAO_ORCAMENTO")?.Valor as "C" | "R",
        [context.parametrosGridItens]
    )

    const [ordemLocalizacao, setOrdemLocalizacao] = useState("")

    const onLocalizarItemPorOrdem = (ordem:number) => {
        const element = document.querySelector(`.item-orcamento-ordem-${ordem}`)
        element?.scrollIntoView()
    }

    

    const cabecalhosColunas = <tr
        key="TableHead_tr"
        id="TableHead_tr"
    >
        {!props.esconderColunaVazia &&
        <th
            id="th-primeira-coluna-grid-itens"
            key="th-primeira-coluna-grid-itens"
            style={obterStyleColunasFixas(null, context.colunas, parametroChaveMovimentacaoOrcamento, false)}
            ></th>}

        {
            context.colunas.map((coluna, key) => (
                coluna?.Selecionada &&
                <th
                    //key={key}
                    key={`th-coluna-${coluna.Nome}-grid-itens_${key}`}
                    id={`th-coluna-${coluna.Nome}-grid-itens_${key}`}
                    style={obterStyleColunasFixas(coluna.Nome, context.colunas, parametroChaveMovimentacaoOrcamento, false)}
                    title={coluna.Nome=="Descricao" ? 'Largura da coluna pode ser configurável como : P, M, G, GG' : ""}
                   >
                    {traduzirNomeColuna({
                        nomeColuna: coluna?.Nome,
                        codigoFilialOrcamento: context.orcamento.CodigoFilialOrcamento
                    })}
                    
                    {coluna.Nome == "OrdemItem" 
                    && <div
                        key={`th-coluna-${coluna.Nome}-grid-itens_Div${key}`}
                        id={`th-coluna-${coluna.Nome}-grid-itens_Div${key}`}
                    >
                    <input 
                        key={`th-coluna-${coluna.Nome}-grid-itens_Input${key}`}
                        id={`th-coluna-${coluna.Nome}-grid-itens_Input${key}`}
                        className={estilosTableHead.inputOrdem}
                        value={(ordemLocalizacao) ?? ""}
                        onKeyDown={e => {
                            
                            if (isNaN(Number(e.key)) && !R.includes(e.key,['Backspace', 'Enter','NumpadEnter'])) {
                                e.preventDefault()
                            }

                            if (R.includes(e.key,['Enter','NumpadEnter'])) {
                                onLocalizarItemPorOrdem(Number(ordemLocalizacao))
                            }
                            
                        }}
                        onChange={e => {
                            setOrdemLocalizacao(e.target.value)
                        }}
                        onBlur={() => onLocalizarItemPorOrdem(Number(ordemLocalizacao))}
                        />
                    </div>}
                </th>
            ))
        }

       
    </tr>
    return <>
        <thead className={estilosTableHead.theadGrid}>

            {cabecalhosColunas}

        </thead>


    </>
}


